document.addEventListener('DOMContentLoaded', function () {
  /* ---------- Cart drawer ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-drawer-overlay]');
  var openTriggers = document.querySelectorAll('[data-cart-drawer-open]');
  var closeTriggers = document.querySelectorAll('[data-cart-drawer-close]');

  function openDrawer(e) {
    if (e) e.preventDefault();
    if (drawer && overlay) {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  }
  function closeDrawer() {
    if (drawer && overlay) {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }
  openTriggers.forEach(function (el) { el.addEventListener('click', openDrawer); });
  closeTriggers.forEach(function (el) { el.addEventListener('click', closeDrawer); });
  if (overlay) overlay.addEventListener('click', closeDrawer);

  /* ---------- Refresh cart drawer contents via Ajax ---------- */
  function refreshCartDrawer() {
    var body = document.querySelector('[data-cart-drawer-body]');
    if (!body) return;
    fetch('/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .catch(function () {});
  }

  /* ---------- Cart quantity controls (drawer + page) ---------- */
  document.body.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-cart-qty-minus]');
    var plus = e.target.closest('[data-cart-qty-plus]');
    if (minus || plus) {
      var key = (minus || plus).getAttribute('data-cart-qty-minus') || (minus || plus).getAttribute('data-cart-qty-plus');
      var input = document.querySelector('[data-cart-qty-input="' + key + '"]');
      if (input) {
        var val = parseInt(input.value, 10) || 0;
        val = minus ? Math.max(0, val - 1) : val + 1;
        input.value = val;
        updateCartLine(key, val);
      }
    }
    var remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      var rKey = remove.getAttribute('data-cart-remove');
      updateCartLine(rKey, 0);
    }
  });

  function updateCartLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () { window.location.reload(); })
      .catch(function () {});
  }

  /* ---------- Product quantity stepper (product page) ---------- */
  document.querySelectorAll('[data-qty-minus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = document.querySelector('[data-qty-input]');
      if (input) input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
  });
  document.querySelectorAll('[data-qty-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = document.querySelector('[data-qty-input]');
      if (input) input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });

  /* ---------- Product gallery thumbnails ---------- */
  var mainImg = document.querySelector('[data-gallery-main] img');
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = thumb.getAttribute('data-full');
      if (mainImg && src) mainImg.setAttribute('src', src);
      document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });

  /* ---------- Add to cart (ajax) ---------- */
  document.querySelectorAll('[data-add-to-cart-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) { submitBtn.setAttribute('disabled', 'disabled'); submitBtn.dataset.originalText = submitBtn.textContent; submitBtn.textContent = 'Adding...'; }

      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (r) { return r.json(); })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function () {
          if (submitBtn) { submitBtn.removeAttribute('disabled'); submitBtn.textContent = submitBtn.dataset.originalText; }
        });
    });
  });

  /* ---------- Header shrink on scroll (for transparent header) ---------- */
  var header = document.querySelector('[data-header]');
  if (header && header.classList.contains('is-transparent')) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 40) {
        header.classList.remove('is-transparent');
      } else {
        header.classList.add('is-transparent');
      }
    });
  }
});
